import { render, staticRenderFns } from "./TextAnswer.vue?vue&type=template&id=a48b2b7e&scoped=true"
import script from "./TextAnswer.vue?vue&type=script&lang=js"
export * from "./TextAnswer.vue?vue&type=script&lang=js"
import style0 from "./TextAnswer.vue?vue&type=style&index=0&id=a48b2b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48b2b7e",
  null
  
)

export default component.exports